import { formatDate, gridSizeMdLg12 } from "@/shared";
import { CustomTextAreaNoForm, CustomTextFieldNoForm } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { City, ISolicitudEvento, Province } from "@/shared/interfaces";
import { Grid } from "@mui/material";

interface IModalSolicitudEvento {
    showModal:boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
    dataSelected: ISolicitudEvento & {
        provincia_data?: Province
        ciudad_data?: City
    }
}


export default function ModalSolicitudEvento({
  showModal,
  setShowModal,
  dataSelected
}:IModalSolicitudEvento) {
  return (
    <>
      {
        showModal?
        <ScrollableDialogProps
        open={showModal}
        title="Información de Evento"
        contentNode={
          <Grid {...gridSizeMdLg12} container spacing={3}>

            {/* <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"NÚMERO DE REGISTRO"}
              value={dataSelected?.numero_referencia}
              defaultValue={dataSelected?.numero_referencia || ""}
            /> */}
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"NOMBRE DEL EVENTO"}
              value={dataSelected?.nombre || ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"FECHA DE INICIO DEL EVENTO"}
              shrink={true}
              value={dataSelected?.fecha_inicio ? formatDate(dataSelected?.fecha_inicio) : ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"FECHA FIN DEL EVENTO"}
              shrink={true}
              value={dataSelected?.fecha_fin ? formatDate(dataSelected?.fecha_fin) : ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"RESPONSABLE DEL EVENTO"}
              value={dataSelected?.responsable || ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"IDENTIFICACIÓN DE RESPONSABLE DEL EVENTO"}
              value={dataSelected?.responsable || ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"SERVICIO A CONTRATAR"}
              value={dataSelected?.servicio || ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"CAPACIDAD"}
              value={dataSelected?.capacidad || ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"PROVINCIA"}
              value={dataSelected?.provincia_data?.nombre || ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"CIUDAD"}
              value={dataSelected?.ciudad_data?.nombre || ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"COORDENADAS"}
              value={dataSelected?.coordenadas || ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"DIRECCIÓN"}
              value={dataSelected?.direccion || ""}
            />

            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"NOMBRE DE CONTACTO"}
              value={dataSelected?.nombre_contacto || ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label={"NÚMERO DE CONTACTO"}
              value={dataSelected?.numero_contacto || ""}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label='Requiere Inspección'
              value={dataSelected?.requiere_inspeccion ? "Sí" : "No"}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label='Requiere Cotización'
              value={dataSelected?.requiere_cotizacion ? "Sí" : "No"}
            />
            <CustomTextFieldNoForm
              disabled
              size={gridSizeMdLg12}
              label='Requiere Fibra Oscura'
              value={dataSelected?.requiere_fibra_oscura ? "Sí" : "No"}
            />
            <CustomTextAreaNoForm
              disabled
              size={gridSizeMdLg12}
              label={"OBSERVACIÓN EVENTO"}
              value={dataSelected?.observaciones?.observacion_evento || ""}
            />

          </Grid>
        }
        showConfirmBtn={false}
        // onConfirm={form.handleSubmit(async () => {
        //   await mutateAsyncProspectoCorp({
        //     id: form.getValues().id_prospecto,
        //     data: {
        //       celular: form.getValues().celular
        //     }
        //   });
        //   reset({ celular: '', id_prospecto: '' });
        //   setShowModal(false);
        // })}
        onClose={() => setShowModal(false)}
      />
      :null
      }
    </>
  )
}
